<template>
  <div class="ndetailApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" :style="'min-height:'+curHeight+'px'">
    <div class="title">{{setNewsDetail.title}}</div>
    <div class="con" v-html="setNewsDetail.content"></div>
    <div class="con" style="padding:0 0 12px 0;text-align:right">
      {{setNewsDetail.createtime}}
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setNewsDetail:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getNewsDetail();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      getNewsDetail:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/newsDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setNewsDetail = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .ndetailApp .el-message-box{
    width:30%
  }
  .ndetailApp{
    max-width:750px;
    margin:0 auto;
    background:#fff;
  }

  .ndetailApp .title{
    text-align:center;
    font-size:18px;
    padding:15px 0;
    font-weight:bold;
    width:96%;
    margin:0 auto
  }
  .ndetailApp .con{
    width:92%;
    margin:0 auto
  }
  .ndetailApp p {
    font-size: 16px;
    color: #333;
    letter-spacing: 1px;
    line-height: 24px;
    text-indent: 2em;
    margin-bottom:15px
  }
  .ndetailApp img {
    display: block;
    margin: 0 auto;
    width:100% !important
  }

</style>